import axios from "axios";

export default {
  namespaced: true,
  state: {
    platforms: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    platformsMessage: ''
  },
  mutations: {
    CLEAR_MARKETPLATFORMS(state) {
      state.platforms = [];
    },
    RECEIVED_MARKETPLATFORMS(state, payload) {
      state.platforms = payload;
      state.isReceiving = false;
    },
    RECEIVING_MARKETPLATFORMS(state) {
      state.isReceiving = true;
    },
    RECEIVED_MARKETPLATFORM(state, payload) {
      state = Object.assign(state, {
        platforms: [...state.platforms, payload],
        isReceiving: false,
      })
    },
    RECEIVING_MARKETPLATFORM(state) {
      state.isReceiving = true;
    },
    UPDATED_MARKETPLATFORM(state, payload) {
      let index = state.platforms.findIndex(platform => platform._id === payload._id);
      state = Object.assign(state, {
        platforms: state.platforms.map((platform, i) => {
          if (i === index) {
            return Object.assign({}, platform, payload);
          }
          return platform;
        }),
        isUpdating: false,
        platformsMessage: 'MarketPlatforms has been updating!',
      })
    },
    UPDATING_MARKETPLATFORM(state) {
      state.isUpdating = true;
    },
    DELETED_MARKETPLATFORM(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.platforms.findIndex(platform => platform._id === payload._id);
      console.log(indexToDelete);
      let platforms = [...state.platforms];
      platforms.splice(indexToDelete, 1);
      state = Object.assign(state, {
        platforms: [...platforms],
        isDeleting: false,
        idToDelete: null,
        platformsMessage: 'MarketPlatform has been Deleted!',
      });
    },
    DELETING_MARKETPLATFORM(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteMarketPlatformRequest({dispatch}, payload) {
      dispatch("deletingMarketPlatform", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/platform/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteMarketPlatform", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async insertMarketPlatformRequest({dispatch}, payload) {
      dispatch("receivingMarketPlatforms");
      var token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/marketplatform';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveMarketPlatform", response.data);
      return response.data;
    },
    async insertMarketPlatformWithImageRequest({dispatch}, payload) {
      console.log(payload)
      dispatch("receivingMarketPlatforms");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/marketplatform/withimage';
      let data = new FormData();
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x]);
      
      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response =>{
        console.log(response)
        dispatch("receiveMarketPlatform", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    async getMarketPlatformsRequest({dispatch}) {
      dispatch("receivingMarketPlatforms");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.accountxc.com:3100/get/marketplatforms';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        dispatch("receiveMarketPlatforms", response.data);
      })
    },
    async getMarketPlatformQueryRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketPlatforms");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/platforms/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveMarketPlatforms", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketPlatformRequest({dispatch}, payload) {
      dispatch("updatingMarketPlatform");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/marketplatform/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateMarketPlatform", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateMarketPlatformTokenRequest({dispatch}, payload) {

      try{
        console.log(payload)
        dispatch("updatingMarketPlatform");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let url = 'https://api.accountxc.com:3100/update/marketplatform/token/' + id;
        let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketPlatform", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketPlatformImageRequest({dispatch}, payload) {
      dispatch("updatingMarketPlatform");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.accountxc.com:3100/update/marketplatform/image/' + id;
      let data = new FormData();
      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x])
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      return axios({method: "PUT", url: url, headers: headers, data: data})
      .then(response=>{
        dispatch("updateMarketPlatform", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    clearMarketPlatforms({commit}) {
      commit("CLEAR_MARKETPLATFORMS")
    },
    receiveMarketPlatforms({commit}, payload) {
      commit("RECEIVED_MARKETPLATFORMS", payload)
    },
    receivingMarketPlatforms({commit}) {
      commit("RECEIVING_MARKETPLATFORMS")
    },
    receiveMarketPlatform({commit}, payload) {
      commit("RECEIVED_MARKETPLATFORM", payload)
    },
    receivingMarketPlatform({commit}) {
      commit("RECEIVING_MARKETPLATFORM")
    },
    updateMarketPlatform({commit}, payload) {
      commit("UPDATED_MARKETPLATFORM", payload)
    },
    updatingMarketPlatform({commit}) {
      commit("UPDATING_MARKETPLATFORM")
    },
    deleteMarketPlatform({commit}, payload) {
      commit("DELETED_MARKETPLATFORM", payload)
    },
    deletingMarketPlatform({commit}, payload) {
      commit("DELETING_MARKETPLATFORM", payload)
    }
  },
};
